<template>
  <div>

    <template v-if="!user">

      <template
          v-if="$route.query && ('register' in this.$route.query || 'forgot_password' in this.$route.query
          || 'change_password' in this.$route.query || 'confirm_registration' in this.$route.query)">
        <template v-if="'register' in this.$route.query && this.$route.query.register == 'yes'">
          <div class="notice notice_type_info">
            <div class="notice__content">
              Наша Компания осуществляет только оптовую продажу игрушек. Мы сотрудничаем только
              с юридическими лицами и индивидуальными предпринимателями на основании
              договоров поставки.
            </div>
          </div>

          <div class="person person_registration">
            <h1 class="person__title">Регистрация</h1>

            <template v-if="isSend">
              <p class="person__text">
                На указанный вами e-mail было выслано письмо с информацией о подтверждении почтового ящика, пожалуйста,
                перейдите по ссылке в нем, чтобы завершить регистрацию.
              </p>
            </template>
            <template v-else>
              <p class="person__text">
                После отправки данных с вами свяжется менеджер
                для их подтверждения.
              </p>

              <p class="person__text">
                * - поля обязательны к заполнению.
              </p>

              <div class="person__ui-form">
                <form method="post" @submit.prevent="isUseCaptcha ? validate() : register()"
                      class="form-data form-data_type_ui_registration form-data_theme_bordered">

                  <fieldset class="form-data__group">
                    <legend class="form-data__group-title">Данные организации</legend>

                    <div class="form-data__parametr form-data__parametr_row">
                      <label class="form-data__label">ИНН <span
                              class="bx-authform-starrequired">*</span></label>
                      <ValidationProvider
                              name="ИНН"
                              rules="required"
                              v-slot="{ errors }"
                      >
                        <input type="text" name="UF_INN" id="inn" v-model="orgInn" class="form-data__input require"
                               required>
                        <span class="form-data__error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>


                    <div class="form-data__parametr form-data__parametr_row">
                      <label class="form-data__label">Полное название <span
                              class="bx-authform-starrequired">*</span></label>
                      <ValidationProvider
                              name="Полное название"
                              rules="required"
                              v-slot="{ errors }"
                      >
                        <input type="text" name="WORK_COMPANY" v-model="orgName" class="form-data__input require"
                               required>
                        <span class="form-data__error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <div class="form-data__parametr form-data__parametr_row">
                      <label class="form-data__label">Страна <span class="bx-authform-starrequired">*</span></label>
                      <div class="fo-select-block select select_theme_bordered js-select"
                           style="width: -webkit-calc(100% - 205px);width: calc(100% - 205px);">
                        <ValidationProvider
                                name="Страна"
                                rules="required"
                                v-slot="{ errors }"
                        >
                          <select name="UF_COUNTRY" class="select__input require" v-model="orgCountry" required>
                            <option v-for="country in countries" :value="country.id">{{ country.label }}</option>
                          </select>
                          <span class="form-data__error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>

                    <div class="form-data__parametr form-data__parametr_row">
                      <label class="form-data__label">Основной телефон</label>
                      <ValidationProvider
                              name="Основной телефон"
                              :rules="{ regex: /\+?\d\s*\(?-?\s*(\d{3})\s*\)?-?\s*(\d{3})\s*-?\s*(\d{2})\s*-?\s*(\d{2})(\s+(д\.?|доб\.?|ext\.?)?\s*\(?([\d-]{1,5})\)?)?/ }"
                              v-slot="{ errors }"
                      >
                        <input type="tel" name="WORK_PHONE" v-model="orgPhone"
                               class="form-data__input">
                        <span class="form-data__error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <div class="form-data__parametr form-data__parametr_row">

                      <label class="form-data__label">
                        Федеральный округ <span class="bx-authform-starrequired">*</span>
                      </label>
                      <div class="fo-select-block select select_theme_bordered js-select"
                           style="width: -webkit-calc(100% - 205px);width: calc(100% - 205px);">
                        <ValidationProvider
                                name="Федеральный округ"
                                rules="required"
                                v-slot="{ errors }"
                        >
                          <select name="UF_FO" class="select__input require" v-model="orgFo" required>
                            <option value="">(не выбрано)</option>
                            <option v-for="fo in fos" :value="fo.id">{{ fo.label }}</option>
                          </select>
                          <span class="form-data__error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>

                    </div>

                    <div class="form-data__parametr form-data__parametr_row">
                      <label class="form-data__label">Город <span class="bx-authform-starrequired">*</span></label>
                      <ValidationProvider
                              name="Город"
                              rules="required"
                              v-slot="{ errors }"
                      >
                        <input type="text" name="WORK_CITY" v-model="orgCity" class="form-data__input require" required>
                        <span class="form-data__error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                  </fieldset>

                  <fieldset class="form-data__group">
                    <legend class="form-data__group-title">Личные данные</legend>

                    <div class="form-data__parametr form-data__parametr_row">
                      <label class="form-data__label">Контактное лицо (ФИО) <span
                          class="bx-authform-starrequired">*</span></label>
                      <ValidationProvider
                          name="Контактное лицо"
                          :rules="{ regex: /[а-яА-яёЁ\s-]+/m }"
                          v-slot="{ errors }"
                      >
                        <input type="text" name="USER_NAME" v-model="name" class="form-data__input require" required>
                        <span class="form-data__error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <div class="form-data__parametr form-data__parametr_row">
                      <label class="form-data__label">E-mail <span class="bx-authform-starrequired">*</span></label>
                      <ValidationProvider
                          name="E-mail"
                          rules="required|email"
                          v-slot="{ errors }"
                      >
                        <input type="email" name="USER_EMAIL" @blur="checkMail" v-model="email" class="form-data__input require" required>
                        <span class="form-data__error">{{ errors[0] }}</span>
                      </ValidationProvider>
                      <div class="form-data__message"><span class="form-data__error" v-html="message"></span></div>
                    </div>

                    <div class="form-data__parametr form-data__parametr_row ">
                      <label class="form-data__label">Контактный телефон <span class="bx-authform-starrequired">*</span></label>
                      <ValidationProvider
                          name="Контактный телефон"
                          :rules="{ regex: /\+?\d\s*\(?-?\s*(\d{3})\s*\)?-?\s*(\d{3})\s*-?\s*(\d{2})\s*-?\s*(\d{2})/ }"
                          v-slot="{ errors }"
                      >
                        <input type="tel" name="PERSONAL_PHONE" v-model="phone" v-mask="phoneMask"
                               class="form-data__input require" required>
                        <span class="form-data__error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </fieldset>

                  <fieldset class="form-data__group">

                    <div class="form-data__parametr form-data__parametr_row">
                      <label class="form-data__label">Пароль</label>
                      <ValidationProvider
                          name="Пароль"
                          rules="confirmed:passwordConfirm"
                          v-slot="{ errors }">
                        <input type="password" name="USER_PASSWORD" class="form-data__input require" v-model="password"
                               required>
                        <span class="form-data__error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <div class="form-data__parametr form-data__parametr_row">
                      <label class="form-data__label">Повторите пароль</label>
                      <ValidationProvider
                          name="Повторите пароль"
                          v-slot="{ errors }"
                          vid="passwordConfirm">
                        <input type="password" name="USER_CONFIRM_PASSWORD" class="form-data__input require"
                               v-model="passwordConfirm" required ref="repeatedPasswordEl">
                        <span class="form-data__error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <template v-if="isUseCaptcha">
                      <vue-recaptcha
                          ref="recaptcha"
                          size="invisible"
                          :sitekey="siteKey"
                          @verify="register"
                          @expired="onCaptchaExpired"
                      />
                    </template>

                    <div class="form-data__parametr form-data__parametr_row_full">
                      <a href="/auth/" class="form-data__action-link">У меня уже есть аккаунт</a>

                      <button name="Register"
                              type="submit"
                              class="form-data__button button button_theme_primary_blue button_size_md">
                        Зарегистрироваться
                      </button>
                    </div>
                  </fieldset>
                </form>
              </div>

            </template>
          </div>
        </template>
        <template v-if="'forgot_password' in this.$route.query && this.$route.query.forgot_password == 'yes'">
          <div class="person person_enter">

            <h1 class="person__title">
              Восстановление
            </h1>

            <div class="person__ui-form">

              <form method="post" @submit="forgotPassword"
                    class="form-data form-data_type_ui_enter form-data_theme_bordered">
                <div class="form-data__parametr form-data__parametr_row">
                  <label class="form-data__label">E-mail</label>
                  <ValidationProvider
                      name="E-mail"
                      rules="required|email"
                      v-slot="{ errors }"
                  >
                    <input type="email" name="USER_EMAIL" v-model="email" class="form-data__input require" required>
                    <span class="form-data__error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-data__message"><span class="form-data__error" v-html="message"></span></div>

                <div class="form-data__parametr form-data__parametr_row_full ">
                  <a href="/auth/?register=yes" class="form-data__action-link">Зарегистрироваться</a>

                  <button type="submit" name="send_account_info"
                          class="form-data__button button button_theme_primary_blue button_size_md">
                    Восстановить
                  </button>
                </div>
              </form>
            </div>

          </div>
        </template>
        <template v-if="'change_password' in this.$route.query && this.$route.query.change_password == 'yes'">
          <div class="person person_enter">

            <h1 class="person__title">
              Изменение пароля
            </h1>

            <div class="person__ui-form">

              <form name="form_auth" method="post" @submit="changePassword" class="form-data form-data_theme_bordered">

                <div class="form-data__parametr form-data__parametr_row">
                  <label class="form-data__label">Логин</label>
                  <ValidationProvider
                      name="Логин"
                      rules="required|email"
                      v-slot="{ errors }"
                  >
                    <input type="email" name="USER_LOGIN" v-model="login" class="form-data__input require" required>
                    <span class="form-data__error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-data__parametr form-data__parametr_row">
                  <label class="form-data__label">Контрольная строка</label>
                  <ValidationProvider
                      name="Контрольная строка"
                      rules="required"
                      v-slot="{ errors }"
                  >
                    <input type="text" name="USER_CHECKWORD" v-model="checkWord" class="form-data__input require"
                           required>
                    <span class="form-data__error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-data__parametr form-data__parametr_row">
                  <label class="form-data__label">Пароль</label>
                  <ValidationProvider
                      name="Пароль"
                      rules="confirmed:passwordConfirm"
                      v-slot="{ errors }">
                    <input type="password" name="USER_PASSWORD" class="form-data__input require" v-model="password"
                           required>
                    <span class="form-data__error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-data__parametr form-data__parametr_row">
                  <label class="form-data__label">Повторите пароль</label>
                  <ValidationProvider
                      name="Повторите пароль"
                      v-slot="{ errors }"
                      vid="passwordConfirm">
                    <input type="password" name="USER_CONFIRM_PASSWORD" class="form-data__input require"
                           v-model="passwordConfirm" required ref="repeatedPasswordEl">
                    <span class="form-data__error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div class="form-data__message"><span class="form-data__error" v-html="message"></span></div>
                </div>

                <div class="form-data__parametr form-data__parametr_row_full">
                  <a href="/auth/" class="form-data__action-link">Авторизация</a>

                  <button type="submit" name="change_pwd"
                          class="form-data__button button button_theme_primary_blue button_size_md">
                    Изменить пароль
                  </button>
                </div>

              </form>
            </div>

          </div>
        </template>
        <template v-if="'confirm_phone' in this.$route.query && this.$route.query.confirm_registration == 'yes'">

          <div class="person person_enter">

            <h1 class="person__title">
              Подтверждение регистрации
            </h1>

            <div class="person__ui-form">
              <form name="confirmation_auth" method="post" @submit.prevent="confirmation" class="form-data form-data_theme_bordered">

                <div class="form-data__parametr form-data__parametr_row">
                  <label class="form-data__label">Email</label>
                  <ValidationProvider
                      name="Email"
                      rules="required|email"
                      v-slot="{ errors }"
                  >
                    <input type="email" name="USER_EMAIL" v-model="email" class="form-data__input require" required>
                    <span class="form-data__error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-data__parametr form-data__parametr_row">
                  <label class="form-data__label">Код подтверждения</label>
                  <ValidationProvider
                      name="Код подтверждения"
                      rules="required"
                      v-slot="{ errors }"
                  >
                    <input type="text" name="CONFIRM_CODE" v-model="confirmCode" class="form-data__input require" required>
                    <span class="form-data__error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div class="form-data__message"><span class="form-data__error" v-html="message"></span></div>
                </div>

                <div class="form-data__parametr form-data__parametr_row_full">
                  <button type="submit" name="confirm_code"
                          class="form-data__button button button_theme_primary_blue button_size_md">
                    Подтвердить
                  </button>
                </div>
              </form>
            </div>

          </div>

        </template>
        <template v-if="'confirm_registration' in this.$route.query && this.$route.query.confirm_registration == 'yes'">

          <div class="person person_enter">

            <h1 class="person__title">
              Подтверждение регистрации
            </h1>

            <div class="person__ui-form">
              <form name="confirmation_auth" method="post" @submit.prevent="confirmation" class="form-data form-data_theme_bordered">

                <div class="form-data__parametr form-data__parametr_row">
                  <label class="form-data__label">Email</label>
                  <ValidationProvider
                      name="Email"
                      rules="required|email"
                      v-slot="{ errors }"
                  >
                    <input type="email" name="USER_EMAIL" v-model="email" class="form-data__input require" required>
                    <span class="form-data__error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-data__parametr form-data__parametr_row">
                  <label class="form-data__label">Код подтверждения</label>
                  <ValidationProvider
                      name="Код подтверждения"
                      rules="required"
                      v-slot="{ errors }"
                  >
                    <input type="text" name="CONFIRM_CODE" v-model="confirmCode" class="form-data__input require" required>
                    <span class="form-data__error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div class="form-data__message"><span class="form-data__error" v-html="message"></span></div>
                </div>

                <div class="form-data__parametr form-data__parametr_row_full">
                  <button type="submit" name="confirm_code"
                          class="form-data__button button button_theme_primary_blue button_size_md">
                    Подтвердить
                  </button>
                </div>
              </form>
            </div>

          </div>

        </template>
      </template>

      <template v-else>

        <div class="person person_enter">
          <h1 class="person__title">Авторизация</h1>

          <div class="person__ui-form">
            <form name="form_auth" @submit="authForm"
                  class="form-data form-data_type_ui_enter form-data_theme_bordered">

              <div class="form-data__parametr form-data__parametr_row">
                <label class="form-data__label">E-mail</label>
                <ValidationProvider
                    name="E-mail"
                    rules="required|email"
                    v-slot="{ errors }"
                >
                  <input type="email" class="form-data__input" v-model="login" name="USER_LOGIN">
                  <span class="form-data__error">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="form-data__parametr form-data__parametr_row">
                <label class="form-data__label">Пароль</label>
                <ValidationProvider
                    name="Пароль"
                    rules="required"
                    v-slot="{ errors }"
                >
                  <input type="password" maxlength="255" autocomplete="off" class="form-data__input"
                         name="USER_PASSWORD"
                         v-model="password">
                  <span class="form-data__error">{{ errors[0] }}</span>
                </ValidationProvider>
                <div class="form-data__message"><span class="form-data__error" v-html="message"></span></div>
                <div class="form-data__parametr-box">
                  <a href="/auth/?forgot_password=yes" class="form-data__hint-link">Забыли
                    пароль?</a>
                </div>
              </div>

              <div class="login-popup-checbox-block form-data__parametr-box">
                <input type="checkbox" class="adm-designed-checkbox" id="USER_REMEMBER" name="USER_REMEMBER" value="Y"
                       tabindex="3"><label for="USER_REMEMBER" class="adm-designed-checkbox-label"></label>
                <label for="USER_REMEMBER" class="login-popup-checkbox-label">Запомнить меня на этом компьютере</label>
              </div>

              <div class="form-data__parametr form-data__parametr_row_full ">
                <a href="/auth/?register=yes" class="form-data__action-link">Зарегистрироваться</a>

                <button name="Login" type="submit"
                        class="form-data__button button button_theme_primary_blue button_size_md">Войти
                </button>
              </div>
            </form>

          </div>
        </div>
      </template>

    </template>
    <template v-else>
      <p class="notetext">Вы зарегистрированы и успешно авторизовались.</p>
      <p><a href="/">Вернуться на главную страницу</a></p>
    </template>

  </div>
</template>

<script>
import axios from "axios";
import { VueRecaptcha } from 'vue-recaptcha';
import {ValidationProvider, extend, localize} from 'vee-validate';
import {regex, confirmed, required, email} from 'vee-validate/dist/rules';
import ru from 'vee-validate/dist/locale/ru.json';
import MD5 from "crypto-js/md5";


import { createSuggestions } from "@dadata/suggestions";


const token = "5766694ace1390d4c8e573cb8bba87ac3872d1ba";


localize('ru', ru);
extend('regex', regex);
extend('confirmed', confirmed);
extend('email', email);
extend('required', required);

export default {
  name: "Register",
  data: function () {
    return {
      login: '',
      password: '',
      passwordConfirm: '',
      name: '',
      email: '',
      phone: '',
      orgInn: '',
      orgName: '',
      orgPhone: '',
      orgCountry: 1,
      orgFo: '',
      orgCity: '',
      backUrl: Object.keys(this.$route.query).length && 'backurl' in this.$route.query ? window.atob(this.$route.query.backurl) : null,
      message: '',
      isSend: false,
      user: this.$ls.get('user') ?? null,
      fos: [],
      countries: [],
      siteKey: process.env.RECAPTCHA_SITE_KEY,
      isUseCaptcha: Boolean(process.env.RECAPTCHA_ENABLED),
      salt: '',
      checkWord: null,
      confirmCode: null,
      id: null,
      maskExt: ['+7 (', /\d/, /\d/, /\d/, ') ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\s/, 'доб\. ', /\d/, /\d/, /\d/, /\d/],
      countryMasks:[
        {
          countryId:1,
          mask:'+7 (###) ###-##-##'
        },
      ],
    }
  },
  computed: {
    phoneMask() {
      let mask = '';
      let vm = this;
      vm.countryMasks.forEach(function (obj) {
        if (vm.orgCountry == obj.countryId)
          mask = obj.mask
      });
      return mask;
    },
  },
  mounted() {
    if ('register' in this.$route.query && this.$route.query.register == 'yes')
      this.loadFo();

    this.login = 'USER_LOGIN' in this.$route.query && this.$route.query.USER_LOGIN ? this.$route.query.USER_LOGIN : null;
    this.checkWord = 'USER_CHECKWORD' in this.$route.query && this.$route.query.USER_CHECKWORD ? this.$route.query.USER_CHECKWORD : null;
    this.confirmCode = 'confirm_code' in this.$route.query && this.$route.query.confirm_code ? this.$route.query.confirm_code : null;
    this.id = 'confirm_user_id' in this.$route.query && this.$route.query.confirm_user_id ? this.$route.query.confirm_user_id : null;
    if (this.id)
      this.getMail(this.id);

    let vm = this;
    const partyInput = document.getElementById("inn");
    createSuggestions(partyInput, {
      token,
      type: "party",
      count: 5,
      // начинаем показывать Подсказки только с 10 символа
      minChars: 3,
      formatSelected,
    });

    function formatSelected(suggestion) {
      vm.orgName = suggestion.data.name.full_with_opf;
      vm.orgCity = suggestion.data.address.data.city;
      vm.orgInn = suggestion.data.inn;
      return suggestion.data.inn || "";
    }

  },
  methods: {
    getMail: function (id) {
      let vm = this;
      axios.post(
          '/api/user/getMailById',
          {
            id: id,
          },
          {
            headers: {
              'content-type': 'application/json; charset=utf8',
              'X-Requested-With': 'XMLHttpRequest',
            }
          }
      )
          .then(function (response) {
            if (response.data.status) {
              vm.email = response.data.result;
            }
          })
          .catch(function (error) {
            console.log(error);
          });

    },
    auth: function(user) {
      this.user = user;
      this.$ls.set('user', user);
      document.dispatchEvent(new CustomEvent("updateProfile", {detail: user}));

      //ToDo: Заменить на $router.push при полном переходе на Vue
      //this.$router.push(this.backUrl);

      let backUrl = this.backUrl;
      if (backUrl) {
        if (backUrl.indexOf(':') < 0)
          backUrl = window.location.origin + this.backUrl;
      } else {
        backUrl = window.location.origin;
      }
      window.location.href = backUrl;
    },
    confirmation: function (e) {
      let vm = this;
      if (vm.email) {
        console.log('confirmation');
        axios.post(
            '/api/user/confirm',
            {
              email: vm.email,
              confirmCode: vm.confirmCode,
            },
            {
              headers: {
                'content-type': 'application/json; charset=utf8',
                'X-Requested-With': 'XMLHttpRequest',
              }
            }
        )
            .then(function (response) {
              if (response.data.status) {
                vm.isSend = true;

                vm.auth(response.data.result)
              } else {
                vm.message = response.data.message;
              }

              e.preventDefault();
            })
            .catch(function (error) {
              console.log(error);
            });
      } else {
        vm.message = '';
      }
    },
    checkMail: function (e) {
      let vm = this;
      if (vm.email) {
        axios.post(
            '/api/user/mail',
            {
              email: vm.email,
            },
            {
              headers: {
                'content-type': 'application/json; charset=utf8',
                'X-Requested-With': 'XMLHttpRequest',
              }
            }
        )
            .then(function (response) {
              if (!response.data.status) {
                vm.message = response.data.message;
              } else {
                vm.message = '';
              }
            })
            .catch(function (error) {
              console.log(error);
            });
      } else {
        vm.message = '';
      }
    },
    changePassword: function (e) {
      let vm = this;
      axios.post(
          '/api/user/change',
          {
            login: vm.login,
            password: vm.password,
            passwordConfirm: vm.passwordConfirm,
            checkWord: vm.checkWord,
          },
          {
            headers: {
              'content-type': 'application/json; charset=utf8',
              'X-Requested-With': 'XMLHttpRequest',
            }
          }
      )
          .then(function (response) {
            if (response.data.status) {
              vm.isSend = true;

              vm.message = response.data.message;
              vm.auth(response.data.result);
            } else {
              vm.message = response.data.message;
            }
          })
          .catch(function (error) {
            console.log(error);
          });

      e.preventDefault();
    },
    forgotPassword: function (e) {
      let vm = this;
      axios.post(
          '/api/user/forgot',
          {
            email: vm.email,
          },
          {
            headers: {
              'content-type': 'application/json; charset=utf8',
              'X-Requested-With': 'XMLHttpRequest',
            }
          }
      )
          .then(function (response) {
            if (response.data.status) {
              vm.isSend = true;
              vm.message = response.data.message;
            } else {
              vm.message = response.data.message;
            }
          })
          .catch(function (error) {
            console.log(error);
          });

      e.preventDefault();
    },
    authForm: function (e) {
      let vm = this;
      axios.post(
          '/api/user/auth',
          {
            login: this.login,
            password: this.password
          },
          {
            headers: {
              'content-type': 'application/json; charset=utf8',
              'X-Requested-With': 'XMLHttpRequest',
            }
          }
      )
          .then(function (response) {
            if (response.data.status) {
              vm.isSend = true;

              vm.auth(response.data.result.user)
            } else {
              vm.message = response.data.message;
            }
          })
          .catch(function (error) {
            console.log(error);
          });


      e.preventDefault();
    },
    loadFo: function () {

      let vm = this;
      axios.post(
          '/api/user/location',
          {
          },
          {
            headers: {
              'content-type': 'application/json; charset=utf8',
              'X-Requested-With': 'XMLHttpRequest',
            }
          }
      )
          .then(function (response) {
            if (response.data.status) {
              vm.fos = response.data.result.fo;
              vm.countries = response.data.result.country;
              vm.salt = response.data.result.salt;
            }
          })
          .catch(function (error) {
            console.log(error);
          });


    },
    register: function (recaptchaToken = false) {
      let vm = this;
      axios.post(
          '/api/user/register',
          {
            name: this.name,
            email: this.email,
            password: this.password,
            passwordConfirm: this.passwordConfirm,
            phone: this.phone,
            orgInn: this.orgInn,
            orgName: this.orgName,
            orgPhone: this.orgPhone,
            orgCountry: this.orgCountry,
            orgFo: this.orgFo,
            orgCity: this.orgCity,
            recaptchaToken: recaptchaToken,
            checkBit: MD5(this.email + this.password + this.phone + this.salt).toString()
          },
          {
            headers: {
              'content-type': 'application/json; charset=utf8',
              'X-Requested-With': 'XMLHttpRequest',
            }
          }
      )
          .then(function (response) {
            if (response.data.status && response.data.result) {
              vm.isSend = true;
              vm.message = response.data.message;
              document.querySelector('.person_registration').scrollIntoView();
            }
          })
          .catch(function (error) {
            console.log(error);
          });

    },
    validate() {
      // тут можно добавить проверку на валидацию
      // например, с помощью vee validate
      // если с валидацией наших полей все хорошо, запускаем каптчу
      this.$refs.recaptcha.execute()
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    }
  },
  components: {
    VueRecaptcha,
    ValidationProvider
  }
}
</script>

<style scoped>

</style>